import LoadingCover from './LoadingCover';

interface OwnProps {
  background?: string;
}
const LoadingPage = (props: OwnProps) => {
  return <LoadingCover {...props} />;
};

export default LoadingPage;
